import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useDashboardTitleStyles = makeThemedStyles("DashboardTitle", (theme) => ({
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    fontSize: "18px",
    fontWeight: 500,
    color: "#444",
    marginBottom: "10px",
  },
}));

const DashboardTitle = (props: React.PropsWithChildren<{}>) => {
  const styles = useDashboardTitleStyles();
  return <div className={styles.root}>{props.children}</div>;
};

export default DashboardTitle;
